import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, List, Skeleton, Typography } from 'antd';
import Pagination from '../common/pagination';
import RegulationsDetailCard from './regulationsDetailCard';
import { LoadingOutlined } from '@ant-design/icons';
const RegulationsDetailCardList = ({ data, dataSize, currentPage, handleOnPageChange }) => (_jsxs(Card, { style: { borderRadius: '0px' }, title: _jsxs(Typography.Text, { children: ["Regulations Search Result (Total Records:", ' ', dataSize === -1 ? _jsx(LoadingOutlined, {}) : dataSize, ")"] }), children: [_jsx(List, { grid: {
                gutter: 16,
                xs: 1,
                sm: 1,
                md: 1,
                lg: 2,
                xl: 2,
                xxl: 2
            }, dataSource: data, renderItem: (item) => (_jsx(List.Item, { children: item.strRegLibId ? (_jsx(RegulationsDetailCard, { data: item })) : (_jsx(Card, { children: _jsx(Skeleton, { avatar: true, paragraph: { rows: 4 } }) })) })) }), dataSize && (_jsx(Card, { size: "small", children: _jsx(Pagination, { data: { dataSize, currentPage }, handleOnPageChange: handleOnPageChange }) }))] }));
export default RegulationsDetailCardList;
